import type { AIModel } from '@/types';

const THINKING_PREFERENCE_KEY_PREFIX = 'chat-thinking-enabled:';

export function modelSupportsThinking(model: Pick<AIModel, 'supports_reasoning'> | null | undefined) {
  return Boolean(model?.supports_reasoning);
}

export function loadThinkingEnabled(modelId: string | null | undefined) {
  if (typeof window === 'undefined' || !modelId) {
    return false;
  }

  return localStorage.getItem(`${THINKING_PREFERENCE_KEY_PREFIX}${modelId}`) === 'true';
}

export function saveThinkingEnabled(modelId: string | null | undefined, value: boolean) {
  if (typeof window === 'undefined' || !modelId) {
    return;
  }

  localStorage.setItem(`${THINKING_PREFERENCE_KEY_PREFIX}${modelId}`, value ? 'true' : 'false');
}

function extractSection(text: string, label: string) {
  const patterns = [
    new RegExp(`(?:^|\\n)#{1,6}\\s*${label}\\s*:?\\s*\\n([\\s\\S]*?)(?=\\n#{1,6}\\s*(?:Thinking|Answer)\\s*:?\\s*\\n|$)`, 'i'),
    new RegExp(`(?:^|\\n)${label}\\s*:?\\s*\\n([\\s\\S]*?)(?=\\n(?:Thinking|Answer)\\s*:?\\s*\\n|$)`, 'i'),
  ];

  for (const pattern of patterns) {
    const match = text.match(pattern);
    if (match?.[1]?.trim()) {
      return match[1].trim();
    }
  }

  return '';
}

function extractThinkTagSections(text: string) {
  const thinkMatch = text.match(/<think>([\s\S]*?)<\/think>/i);
  if (!thinkMatch?.[1]?.trim()) {
    return null;
  }

  const thinkingText = thinkMatch[1].trim();
  const answerText = text.replace(thinkMatch[0], '').trim();

  return {
    thinkingText,
    answerText,
  };
}

export function extractThinkingSections(text: string) {
  if (!text.trim()) {
    return null;
  }

  const thinkTagSections = extractThinkTagSections(text);
  if (thinkTagSections) {
    return thinkTagSections;
  }

  const thinkingText = extractSection(text, 'Thinking');
  const answerText = extractSection(text, 'Answer');

  if (!thinkingText || !answerText) {
    return null;
  }

  return {
    thinkingText,
    answerText,
  };
}